import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, Spinner } from "reactstrap";

const ConfirmationModal = ({
  show,
  setShow,
  onConfirmClick,
  item, // The user object being activated/deactivated
  title: propTitle,
  description: propDescription,
  confirmBtnText: propConfirmBtnText,
  loading = false,
}) => {
  const { t } = useTranslation();

  const isActivating = item && !item.IsActive; // Determine if the action is activating

  // Use provided props or fall back to default activation/deactivation logic
  const title = propTitle || (isActivating ? "Confirm Activation" : "Confirm Deactivation");
  const description = propDescription || (isActivating
    ? "Are you sure you want to activate this user?"
    : "Are you sure you want to deactivate this user?");
  const confirmBtnText = propConfirmBtnText || (isActivating ? "Yes, Activate" : "Yes, Deactivate");

  const confirmBtnColor = title === "Confirm Activation" ? "success" : "danger";

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal isOpen={show} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{t(title)}</h4> 
            <p className="text-muted mx-4 mb-0">{t(description)}</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={handleClose}
          >
            {t("Close")}
          </button>
          <button
            type="button"
            className={`btn w-sm btn-${confirmBtnColor} d-flex align-items-center justify-content-center`}
            id="confirm-toggle-status"
            onClick={onConfirmClick}
            disabled={loading}
          >
            {loading && (
              <Spinner
                size="sm"
                style={{
                  marginRight: "10px",
                }}
              >
                {" "}
              </Spinner>
            )}
            {t(confirmBtnText)}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  item: PropTypes.object, // Can be null initially
  title: PropTypes.string,
  description: PropTypes.string,
  confirmBtnText: PropTypes.string,
  loading: PropTypes.bool,
};

export default ConfirmationModal;